import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { LocationService } from '../../../../services/location.service';
import { debug } from 'console';
//import { LocalApiConnectorService } from '../../../../services/local-api-connector.service';


@Component({
  selector: 'one-receipt',
  templateUrl: './one-receipt.component.html',
  styleUrls: ['./one-receipt.component.scss'],

})
export class OneReceiptComponent implements OnInit, OnChanges {
  @Input() lock;
  @Input() shippments = [];
  @Input() shipmentsByCurrency = [];
  showShipmentTable = true;
  showPaymentType = false;
  showScanner = false;
  @Output() addShipmentRequest = new EventEmitter();
  @Output() close = new EventEmitter();
  shippmentByTypes = [] as any[];
  consigneeObject: any = { consigneeName: '', phoneNumber: '', emailAddress: '', customerPodIdNumber:'' };
  hasInboundShipment: boolean = false;
  hasOutboundShipment: boolean = false;
  hasMiscShipment: boolean = false;
  hasPackagingShipment: boolean = false;
  hasDropOffShipment = false;
  OutboundIDScanRequired: any;
  PODIDScanRequired: any;
  PODSignatureRequired: any;
  AddAdditionalAmountSetting = JSON.parse(sessionStorage.getItem("branchSettings")).filter(x => x.Key == 41)[0].Value;

  @Input() scanners: any=[];

  constructor(private location: LocationService,
    // private agent: LocalApiConnectorService
     ) { }
  onNewShippmentRequest(type) {
    this.addShipmentRequest.emit(type)
  }
  onCheckOut(event) {
    this.showShipmentTable = false;
    this.showScanner = true;
  }
  @Output() deleteShipment = new EventEmitter();
  onDeleteShipment(event) {
    this.deleteShipment.emit(event)
  }
  @Output() discountShipment = new EventEmitter();
  onChangeDiscount(event) {
    this.discountShipment.emit(event)
  }
  @Output() duplicateShipment = new EventEmitter();
  onDuplicateShipment(event) {
    this.duplicateShipment.emit(event);
  }
  closeRecepit() {
    this.close.emit(true);
  }
  onScannerPrevious() {
    this.showScanner = false;
    this.showPaymentType = false;
    this.showShipmentTable = true;
  }
  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    }
    else {
      if (value || value == 0)
        return '0.00';
      else
        return '';
    }
  }
  onPaymentPrevious() {
    this.showScanner = true;
    this.showPaymentType = false;
    this.showShipmentTable = false;
  }
  shippment = {} as any;
  ngOnChanges(changes: SimpleChanges) {
    var outboundShippment = [];
    var inboundShipment = [];
    var dropOffShipment = [];
    var miscShipment = [];
    var packagingShipment = [];
    var packagingOrigin = JSON.parse(sessionStorage.getItem('company')).BranchCompanyCountryCode;
    try {
      console.log('el shipment abl el x',this.shippments);
      
      this.shippments.filter((x) => {
        var services = x.services as any[];

        if (x.shipmentItems != null) {
          var temp = x.shipmentItems as any[];
          var shipmentItemsArray = [];

          temp.forEach((x) => {
            shipmentItemsArray.push(x.item)
          })
        }
        if (services != null) {
          var servicesCommaSparated = '';
          services.forEach((x) => {
            servicesCommaSparated += x.Code + ',';
          })
        }
        if (x.mode != undefined && x.mode == 'Outbound') {          
          var shippmentsObj = {
            ReceiptDetailId: 0,
            Amount: x.ratedPrice.ratedPrice.TotalAmount,
            Comments: 'Outbound ' + x.ratedPrice.WaybillNumber,
            DiscountAmount: x.discountAmount,
            DiscountValue: x.discountValue,
            DiscountValueBy: x.discountValueBy,
            DiscountComments: x.discountComment == undefined ? "" : x.discountComment,
            IsCancelled: false,
            "SubType": null,
            Type: {
              Description: "Outbound",
              ReceiptTypeId: 2
            },
            Shipment: {
              shortCode: x.consigneeDetails.shortCode,
              shortCodeActive: x.consigneeDetails.shortCodeActive,
              BusinessType: '',
              CCCollectionID: 0,
              CODCollectionID: 0,
              CashOnDelivery: x.ratedPrice.CashOnDelivery,
              ChargeableWeight: x.ratedPrice.ChargeableWeight,
              CollectDocumentNumber: '',
              ConsigneeAddress: x.consigneeDetails.addressLine,
              ConsigneeAttentionOf: x.consigneeDetails.attention,
              ConsigneeName: x.consigneeDetails.name,
              ConsigneeTelephone: x.consigneeDetails.telephone,
              ConsigneeMobile: x.consigneeDetails.mobile,
              ConsigneeEmail: x.consigneeDetails.email,
              ConsigneeReferance:x.consigneeDetails.consigneeReferance,
              ConsigneeReferance2:x.consigneeDetails.consigneeReferance2,
              CustomCollectionID: 0,
              Customs: x.ratedPrice.Customs,
              CustomsDocumentNumber: '',
              CustomsTaxRate: 0,
              DeclaredCustomsAmount: x.ratedPrice.Customs,
              DescriptionOfGoods: x.commodity.selectedCommodity.key == "Other (please specify)" ? x.commodity.description : x.commodity.selectedCommodity.key ,
              DestinationAddress: x.ratedPrice.DestinationAddress,
              destination_Latitude : x.consigneeDetails.latitude,
              destination_Longitude : x.consigneeDetails.longitude,
              GrandTotal: {
                Code: x.ratedPrice.ratedPrice.CurrencyCode,
                Value: this.fixDecimals((x.ratedPrice.ratedPrice.AmountBeforeTax - parseFloat(x.ratedPrice.AdditionalCharges.Value)) + parseFloat(x.ratedPrice.AdditionalCharges.Value) + this.fixDecimals((x.ratedPrice.ratedPrice.AmountBeforeTax - parseFloat(x.ratedPrice.AdditionalCharges.Value) + parseFloat(x.ratedPrice.AdditionalCharges.Value)) * x.ratedPrice.ratedPrice.TaxRate)),
              },
              OutboundAdditionalCharges: x.OutboundAdditionalCharges,
              Insurance: x.ratedPrice.Insurance,
              Number: x.ratedPrice.WaybillNumber,
              OriginAddress: x.ratedPrice.OriginAddress,
              OutboundDocumentNumber: null,
              PaymentType: x.ratedPrice.PaymentType,
              ProductGroup: x.productGroup,
              ProductType: x.productType.Code,
              Quantity: x.shipmentItems.length,
              RatedPrice: {
                Code: x.ratedPrice.ratedPrice.CurrencyCode,
                Value: (this.AddAdditionalAmountSetting == "True") ? this.fixDecimals(x.ratedPrice.ratedPrice.AmountBeforeTax) : this.fixDecimals(x.ratedPrice.ratedPrice.AmountBeforeTax - parseFloat(x.ratedPrice.AdditionalCharges.Value))
              },
              Reference: x.shipper.shippmentReference,
              Reference2: x.productType.Code == "CAC" ? x.consigneeDetails.referance2:0,
              Services: servicesCommaSparated,
              ShipmentId: 0,
              ShipperAccountNumber: x.shipper.accountNumber,
              ShipperAddress: x.shipper.addressLine,
              ShipperMobile: x.shipper.mobile,
              ShipperTaxNumber: x.shipper.taxNumber != '' ?  x.shipper.taxNumber : '',
              ShipperName: x.shipper.name,
              ShipperType:x.shipper.shipperType,
              ShipperTypeDetails: x.shipper.shipperTypeDetails,
              ShipperTelephone: x.shipper.mobile,
              ShipperEmail: x.shipper.email,
              shipperReferance: x.shipper.ShipperReference,
              shipperReferance2: x.shipper.ShipperReference2,
              ShipperAccountTaxRate: x.ratedPrice.ratedPrice.TaxRate,
              ShipperAccountTaxable: x.ratedPrice.ratedPrice.TaxRate != null ? parseFloat(x.ratedPrice.ratedPrice.TaxRate) > 0 : false,
              TaxAmount: {
                Code: x.ratedPrice.ratedPrice.CurrencyCode,
                Value: this.fixDecimals(x.ratedPrice.ratedPrice.TaxAmount)//this.fixDecimals((x.ratedPrice.ratedPrice.AmountBeforeTax - parseFloat(x.ratedPrice.AdditionalCharges.Value) + parseFloat(x.ratedPrice.AdditionalCharges.Value)) * x.ratedPrice.ratedPrice.TaxRate)
              },
              ShipperSentBy: x.shipper.name,
              WeightFactor: 0,
              TotalCharges: x.ratedPrice.AdditionalCharges,
              Items: shipmentItemsArray,
            },
            commercialInvoice: x.commercialInvoice
          }
          outboundShippment.push(shippmentsObj);
          console.log('sdasdasd: ', shippmentsObj);
          
        }
        else if (x.mode != undefined && x.mode == 'Inbound') {
          var obj = {
            ReceiptDetailId: 0,
            Amount: x.RatedPrice.Value != null ? x.RatedPrice.Value : null,
            Comments: 'Inbound ' + x.Number,
            DiscountAmount: 0,
            DiscountComments: '',
            IsCancelled: false,
            "SubType": null,
            Type: {
              Description: "Inbound",
              ReceiptTypeId: 1
            },
            Shipment: x
          }
          inboundShipment.push(obj)
        }
        else if (x.mode != undefined && x.mode == 'DropOff') {
          
          
          let obj = {
            hasRTIShipment: x.hasRTIShipment,
            Status: x.Status,
            damagedItems: x.damagedItems,
            ReceiptDetailId: 0,
            Amount: x.NewCost.Value != null ? x.NewCost.Value : null,
            Comments: 'DropOff ' + x.Number,
            DiscountAmount: x.discountAmount,
            DiscountValue: x.discountValue,
            DiscountValueBy: x.discountValueBy,
            DiscountComments: x.discountComment == undefined ? "" : x.discountComment,
            IsCancelled: false,
            "SubType": null,
            Type: {
              Description:"DropOff",
              ReceiptTypeId: 4
            },
            Shipment: {
              ...x,
              ShipperAccountTaxRate: this.getTaxRate(x),
              ShipperAccountTaxable: this.getTaxable(x),
              TaxAmount: {
                Code: x.NewCost.Code,
                Value: this.fixDecimals(this.getTaxAmount(x))
              },
              GrandTotal: {
                ...x.NewCost
              },
              RatedPrice: {
                Code: x.NewCost.Code,
                Value: this.fixDecimals(x.NewCost.Value)
              },
            },
          }          
          dropOffShipment.push(obj);

          this.shippments.push({
            Number: x.Number, // optional but useful
            hasRTIShipment: x.hasRTIShipment,
            Status: x.Status
          });

        }
        //adding packagingObj shipment
        else if (x.mode != undefined && x.mode == 'Packaging'){

          var packagingObj = {
            ReceiptDetailId: 0,
            Amount : x.Shipment.Price,
            Comments: 'Packaging ' + x.Number,
            DiscountAmount:0,
            DiscountValue: null,
            DiscountValueBy: null,
            DiscountComments: '',
            IsCancelled: false,
            "SubType": null,
            Type: {
              Description: "Packaging",
              ReceiptTypeId: 5
            },
            Shipment: {
              ProductType: x.Shipment.ProductType,
              BusinessType: x.Shipment.BusinessType,
              CCCollectionID: x.Shipment.CCCollectionID,
              CODCollectionID: x.Shipment.CODCollectionID,
              CollectDocumentNumber: x.Shipment.CollectDocumentNumber,
              ConsigneeAddress: x.Shipment.ConsigneeAddress,
              ConsigneeName: x.Shipment.ConsigneeName,
              CustomsDocumentNumber:  x.Shipment.CustomsDocumentNumber,
              DestinationAddress:{
                City:x.Shipment.DestinationAddress.City,
                CountryCode:x.Shipment.DestinationAddress.CountryCode,
                Entity:x.Shipment.DestinationAddress.Entity,
                LocatioCode:x.Shipment.DestinationAddress.LocatioCode,
                StateName:'',
                ZipCode:'',
              },
              Number: x.Shipment.Number,
              OriginAddress:{
                City:x.Shipment.OriginAddress.City,
                StateName:x.Shipment.OriginAddress.StateName,
                CountryCode:x.Shipment.OriginAddress.CountryCode,
                ZipCode:x.Shipment.OriginAddress.ZipCode,
                Entity:x.Shipment.OriginAddress.Entity,
                LocationCode:x.Shipment.DestinationAddress.LocatioCode,
              },
              ProductGroup: x.Shipment.ProductGroup,
              RatedPrice:{
                Value:x.Shipment.RatedPrice.Value,
                Code:x.Shipment.RatedPrice.Code
              },
              ShipperAccountTaxRate: x.Shipment.ShipperAccountTaxRate,
              GrandTotal:{
                Value:x.Shipment.GrandTotal.Value,
                Code:x.Shipment.GrandTotal.Code
              },
              TaxAmount: {
                Value: x.Shipment.TaxAmount.Value,
                Code: x.Shipment.TaxAmount.Code
              },
              Price:x.Shipment.Price,
              ShipmentId: 0,
              ShipperAddress: x.Shipment.ShipperAddress,
              ChargeableWeight:{
                  Value:x.Shipment.ChargeableWeight.Value,
                  Unit: x.Shipment.ChargeableWeight.Unit,
              },
              WeightFactor: 0,
              discount: { isLocked: true },
            },
          }
          packagingShipment.push(packagingObj)
        }
        else if (x.mode != undefined && x.mode == 'Misc') {
          var miscObj = {
            category: x.type,
            ReceiptDetailId: 0,
            Amount: x.amount,
            Comments: x.comment,
            DiscountAmount: 0,
            DiscountComments: '',
            IsCancelled: false,
            "Type": {
              Description: "Misc",
              ReceiptTypeId: 3
            },
            SubType: x.type,
            Shipment: {
              ShipmentId: 0,
              Number: x.Number,
              OriginAddress: x.OriginAddress,
              DestinationAddress: x.DestinationAddress,
              ShipperAccountNumber: x.ShipperAccountNumber,
              ShipperAccountTaxable: x.ShipperAccountTaxable,
              ShipperAccountTaxRate: x.ShipperAccountTaxRate,
              ShipperName: x.ShipperName,
              ShipperSentBy: x.ShipperSentBy,
              ShipperTelephone: x.ShipperTelephone,
              ShipperMobile: x.ShipperMobile,
              ShipperAddress: x.ShipperAddress,
              ShipperEmail: x.ShipperEmail,
              ShipperType:x.shipper.shipperType,
              ShipperTypeDetails: x.shipper.shipperTypeDetails,
              ConsigneeName: x.ConsigneeName,
              ConsigneeTelephone: x.ConsigneeTelephone,
              ConsigneeMobile: x.ConsigneeMobile,
              ConsigneeAttentionOf: x.ConsigneeAttentionOf,
              ConsigneeEmail: x.ConsigneeEmail,
              DescriptionOfGoods: x.DescriptionOfGoods,
              Services: x.Services,
              ProductGroup: x.ProductGroup,
              PaymentType: 'C',
              ProductType: x.ProductType,
              Quantity: x.Quantity,
              GrossWeight: x.GrossWeight,
              ChargeableWeight: x.ChargeableWeight,
              WeightFactor: x.WeightFactor,
              RatedPrice: x.RatedPrice,
              CashOnDelivery: x.CashOnDelivery,
              Customs: x.CashOnDelivery,
              CustomsTaxRate: x.CustomsTaxRate,
              DeclaredCustomsAmount: x.DeclaredCustomsAmount,
              Insurance: x.Insurance,
              TotalCharges: x.TotalCharges,
              GrandTotal: x.GrandTotal,
              TaxAmount: x.TaxAmount,
              CCCollectionID: x.CCCollectionID,
              CODCollectionID: x.CODCollectionID,
              CustomCollectionID: x.CustomCollectionID,
              Reference: x.Reference,
              CustomsDocumentNumber: x.CustomsDocumentNumber,
              CollectDocumentNumber: x.CollectDocumentNumber,
              OutboundDocumentNumber: x.OutboundDocumentNumber,
              BusinessType: x.BusinessType,
              CustomsCharges: x.CustomsCharges,
              CollectCharges: x.CollectCharges,
              Items: x.Items
            }
          }
          if (miscObj.category == "SNS Subscription") {
            miscObj.Shipment = null;
          }
          miscShipment.push(miscObj)
          
          console.log(miscObj)
        }
        
      })
      this.shippment.outbound = outboundShippment;
      this.shippment.inbound = inboundShipment;
      this.shippment.dropoff = dropOffShipment;
      this.shippment.misc = miscShipment;
      this.shippment.Packaging = packagingShipment;
      this.shippments = [];
    }
    catch (e) {
      console.log(e.message)
    }
    this.hasInboundShipment = this.shippment['inbound'].length > 0;
    this.hasOutboundShipment = this.shippment['outbound'].length > 0;
    this.hasMiscShipment = this.shippment['misc'].length > 0;
    this.hasDropOffShipment = this.shippment['dropoff'].length > 0;
    this.hasPackagingShipment = this.shippment['Packaging'].length > 0;
    
  }

  getTaxRate(x: any) {
    if (x.RateDetails && x.RateDetails.TaxRate) {
      return x.RateDetails.TaxRate;
    }
    return x.ShipperAccountTaxRate;
  }

  getTaxable(x: any) {
    if (x.RateDetails && x.RateDetails.TaxRate != null) {
      return parseFloat(x.RateDetails.TaxRate) > 0;
    }
    return x.ShipperAccountTaxable;
  }

  getTaxAmount(x: any) {
    if (x.RateDetails && x.RateDetails.TaxAmount != null) {
      return x.RateDetails.TaxAmount;
    }
    return x.TaxAmount.Value;
  }

  checkAmount(AmountObj) {
    var branchCurrencyCode = JSON.parse(sessionStorage.getItem("company")).BranchCurrencyCode;
    if (AmountObj) {
      if (AmountObj.Code == "" || AmountObj.Code == null) {
        AmountObj.Code = branchCurrencyCode;
        return AmountObj;
      }
    }
  }

  ngOnInit() {
    var branchSettings = JSON.parse(sessionStorage.getItem("branchSettings"));
    this.OutboundIDScanRequired = branchSettings.filter(x => x.Key == 3)[0].Value;
    this.PODIDScanRequired = branchSettings.filter(x => x.Key == 4)[0].Value;
    this.PODSignatureRequired = branchSettings.filter(x => x.Key == 5)[0].Value;
    console.log('one receipt ', this.shippments);
    
  }
  files
  onScannerObj(event) {
    this.showScanner = false;
    this.showPaymentType = true;
    this.files = event;
  }

  onConsigneeObj(event) {
    this.consigneeObject.consigneeName = event.consigneeName;
    this.consigneeObject.phoneNumber = event.phoneNumber;
    this.consigneeObject.emailAddress = event.emailAddress;
    this.consigneeObject.customerPodIdNumber = event.customerPodIdNumber;
    this.consigneeObject.consigneeReferance = event.consigneeReferance
    this.consigneeObject.consigneeReferance2 = event.ConsigneeReferance2
  }

}
